import React, { useState, useEffect } from "react";
import axios from "axios";
import busimage from "../../../assets/images/bus.png";
import engineers from "../../../assets/images/engineers.jpg";
import BookingForm from "../Index/BookingForm";
import { Helmet } from "react-helmet";

const Careers = () => {
    const [careerData, setCareerData] = useState({
        name: "",
        email: "",
        password: "",
    });

    const handleChange = (e) => {
        setCareerData({ ...careerData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(
                "http://localhost:5000/api/careers",
                careerData
            );
            //console.log(response.careerData);

            alert(response.data.message);
            setCareerData({
                name: "",
                email: "",
                password: ""

            });
        } catch (error) {
            console.error("Error submitting form:", error);
            alert("Error submitting form");
        }
    };

    return (
        <>
            <Helmet>
                <title>thesolarark.com | Careers | Solar Ark</title>
                <meta
                    name="description"
                    content="At SolarArk Projects Pvt. Ltd., we are shaping the future of renewable energy with innovation and excellence. Join our dynamic team and be part of a mission-driven organization committed to sustainability and technological advancement. We offer exciting career opportunities across sales, marketing, and project management, empowering professionals to grow and make a real impact. With a culture of collaboration, continuous learning, and employee well-being, we foster an environment where talent thrives. If you are passionate about solar energy and looking for a rewarding career, explore opportunities with us and help drive India's clean energy revolution."
                />
                <meta name="theme-color" content="#000000" />
                <meta name="author" content="The Solar Ark" />
                <meta name="robots" content="index, follow" />
                {/* Fallback Open Graph */}
                <meta property="og:type" content="website" />
                <meta property="og:title" content="Solar Ark | Careers" />
                <meta property="og:url" content="https://thesolarark.com/" />

            </Helmet>
            {/* new */}
            <>
                <div className="relative h-40 sm:h-28 lg:my-10 lg:bg-gradient-to-b lg:from-black lg:to-white mobile-header"></div>
                <div className="py-4 flex items-center justify-center">
                    <div className="bg-gray-100 shadow-lg rounded-lg p-8 mb-8 max-w-4xl">
                        {/* Header Section */}
                        <h1 className="text-3xl text-center font-bold text-red-900 mb-5">
                            Empower Your Career with SolarArk
                        </h1>

                        {/* Content Section */}
                        <p className="text-lg mb-6 text-wrap space-y-3">
                            At SolarArk Projects Pvt. Ltd., we are shaping the future of renewable energy with innovation and excellence. Join our dynamic team and be part of a mission-driven organization committed to sustainability and technological advancement. We offer exciting career opportunities across sales, marketing, and project management, empowering professionals to grow and make a real impact. With a culture of collaboration, continuous learning, and employee well-being, we foster an environment where talent thrives. If you are passionate about solar energy and looking for a rewarding career, explore opportunities with us and help drive India's clean energy revolution. <br /><strong className="text-red-900">To apply, please send your CV at <a href="mailto:hr@thesolarark.com" className="underline hover:text-blue-500 text-blue-400">hr@thesolarark.com</a></strong>

                        </p>

                        {/* Benefits List */}

                        {/* Call-to-Action Button */}
                    </div>
                </div>
            </>
            {/* new */}
            <BookingForm />
        </>
    );
};

export default Careers;
